import '../Inscription.less';
import { Layout,Card,Avatar,Comment, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space, AutoComplete,notification, Select,Button } from 'antd';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import Highlighter from 'react-highlight-words';
import { SearchOutlined,StarFilled,FileTextOutlined,CheckOutlined,EditOutlined,FilePdfOutlined, } from '@ant-design/icons';
import moment from 'moment'
import {getAuthors,getAuthorsStr,IP, getComments, downloadFile, readFile} from '../components/utils';
import Foot from "../components/Footer" 
import AdminMenu from "../components/AdminMenu"


class AdminJuryProcess extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;

    this.state={
      plays:[],
      authors:[],
      record:null,
      showCommentSection:false,
      comment:{},
      jurys_dict:{},
      loaded_table_data:false,
      isBusy:true,
    }
  }

  async componentWillMount() {
    //Jury
    const response_jury= await fetch(IP + 'api/musica/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_jury = await response_jury.json();
    if(json_jury['detail']){//check if user is authenticated. If not, response has details key
      localStorage.clear()
      window.location.reload(); 
    }
    const jury_user = localStorage.getItem("User")
    const jurys_dict={}
    Object.entries(json_jury).forEach(element => {
        jurys_dict[element[1].id]=element[1]
    });

    //Qualifications
    var qual_url = new URL(IP + 'api/musica/calificacion/')
    
    const qualifications = await fetch(qual_url);
    const json_qualifications = await qualifications.json()
    const qualifications_dict={}
    const final_qualifications_dict={}
    json_qualifications.forEach(element => {
      if(element.jurado.toString() in jurys_dict){
        if(!(element.obra.toString() in qualifications_dict)){
          qualifications_dict[element.obra]={}
          final_qualifications_dict[element.obra]={}
          for(var j in jurys_dict){
            qualifications_dict[element.obra][j]=null
            final_qualifications_dict[element.obra][j]=null
          }
        }
        qualifications_dict[element.obra][element.jurado]= element.puntaje == 2 ? true : false
        final_qualifications_dict[element.obra][element.jurado]= element.puntaje == 3 ? true : false
      }
    });
    
    //Plays
    const response_plays = await fetch(IP + 'api/musica/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_plays = await response_plays.json();
    
    var data = []
    this.authorsStr = new Set();
    this.auths = new Set();
    this.categories = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    
    const Moment = require('moment');
    
    for(var i in json_plays){
      const item = json_plays[i];
      if(!(item.id.toString() in qualifications_dict) && !(item.id.toString() in final_qualifications_dict))
        continue
      let isPreselected = false
      for(var c in qualifications_dict[item.id]){
        if(qualifications_dict[item.id][c] == true){
          isPreselected = true
          break
        }
      }
      if(!isPreselected){
        continue
      }
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var a= getAuthorsStr(item.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      
      var authorStr = getAuthorsStr(item.conc).join(", ")
      this.auths.add(author)
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.pseudos.add(item.pseudonimo)
      const year = date.split('-')[2]
      this.codes.add(year+'_'+item.id);
      var play = { 
        id : item.id,
        title : item.titulo,
        author: author ,
        authorStr:authorStr,
        date:date,
        pseudo: item.pseudonimo,
        code:year+'_'+item.id,
        conc:item.conc,
        pdf:item.pdf,
        edit:''
      }
   
      for(var j in jurys_dict){
        play[j] = final_qualifications_dict[item.id][j]?<StarFilled style={{color:"#fbb034"}} />: qualifications_dict[item.id][j] ? <CheckOutlined style={{color:"green"}} />:' '
      }
      data.push(play)
    };

    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
    this.categories =[...this.categories].map((v)=>{
      return {value:v}
    })
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({user:jury_user,  jurys_dict:jurys_dict, plays: data ,loaded_table_data:true, qualifications_dict:qualifications_dict});
  }
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
        });
  };

  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex== "author"){
      return  this.authorsStr
    }

    else if (dataIndex== "category"){
      return this.categories
    }
    else if (dataIndex== "pseudo"){
      return this.pseudos
    }
    
    else{
      return this.dates
    }
  }
    getChildComments(comment){
      const { TextArea } = Input;
      return (
        <Comment
        author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
        avatar={
          <Avatar
            src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
            alt={this.state.jurys_dict[comment.jurado].nombre_completo}
          />
        }
        content={
          <p>
           {comment.texto}
          </p>
        }
        datetime={
            <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
        }
      >
        {comment.respuestas.map(id => {
           return this.getChildComments(this.state.comment[id])
        })}
        </Comment>
        )
    }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}
            >
              <Input
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
            </Space>
          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>
           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large', backgroundColor:'white' }}>
              {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a onClick = {()=>this.onClickArticle(record)} >{a.name}</a> </li>})}</ol> )
              || text  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
      async openComments(record){
        var comments_dict = await getComments(record ? record:this.state.record.id)
        this.setState({showCommentSection:true, currentRecordId:record ? record:this.state.record.id, comment:comments_dict})
      }
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };

  render() {
    
      const {  Content } = Layout;
      const Moment = require('moment');
      const columns = [
                
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
                    dataIndex: 'code',
                    key: 'code',
                    width:150,
                    ...this.getColumnSearchProps('code','número'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
                    dataIndex: 'title',
                    key: 'title',
                    ...this.getColumnSearchProps('title','título'),
                    responsive: ['sm'] 
                  },
                
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
                    dataIndex: 'pseudo',
                    key: 'pseudo',
                    ...this.getColumnSearchProps('pseudo','seudónimo'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Género</div>,
                    dataIndex: 'category',
                    key: 'gecategorynre',
                    ...this.getColumnSearchProps('category','género'),
                    responsive: ['sm'] 
                  },    
                  {
                    dataIndex:"pdf",
                    key:"pdf",
                    align:'center',
                    width:95, 
                    render: (text,record)=> {
                      return {
                        props: {
                          style: { background: "white",fontSize:'large' }
                        },
                        children:  
                       <Button onClick={()=>readFile(text)}><FilePdfOutlined/> Leer</Button>
                      }} 
                  },
                  {
                    dataIndex:"id",
                    key:"id",
                    align:'center',
                    width:130 ,
                    render: (text,record)=> {
                      return {
                        props: {
                          style: { background: "white",fontSize:'large',}
                        },
                        children:  
                       <Button onClick={() => downloadFile(record)} ><FilePdfOutlined/>  Descargar</Button>
                      }
                  }},
                  {
                    dataIndex:"id",
                    key:"id",
                    align:'center',
                    render: (text,record)=> {
                      return {
                        props: {
                          style: { background:  "white",fontSize:'large',width:173 }
                        },
                        children:  <div> 
                      <Button onClick={() => this.openComments(record.id)} ><FileTextOutlined />  Comentarios</Button></div>
                      }} 
                  },
            ];
            for(var j in this.state.jurys_dict){
              var column = {
                title: <div style={{fontWeight:'bold', fontSize:'large', position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignElements:'center',}}>{this.state.jurys_dict[j].usuario}</div>,
                dataIndex: j.toString(),
                key: j.toString(),
                width:"100px",
                render: (text,record,index) =>(
                  <div style={{fontSize:'large', backgroundColor: 'white', position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignElements:'center' }}
                  >
                    {text}
                  </div>
                ),
                responsive: ['sm'] }
              columns.push(column)
            }
    const closeComments=()=>{
      this.setState({showCommentSection:false, selected_comment:undefined})
    }
    return (

      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
            <AdminMenu defaultSelectedKey = {"jury_process"}/>
            <Content>
            <Card>
              <Row justify="center" align="middle">
                <Col span={24}>
                  <Table
                    loading={!this.state.loaded_table_data}
                    scroll={{ x: 1300 }}
                    columns={columns}
                    dataSource= {this.state.plays}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='auto'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                  />
                </Col>
              </Row>
            </Card>
            { this.state.showCommentSection && 
              <Modal 
                closable = {false}
                title={ "Comentarios"}
                visible={this.state.showCommentSection} 
                width={580}
                footer={[
                    <Button key="back" onClick={closeComments}>
                    Cerrar
                    </Button>,
                ]}
              >
                <Row align="middle" justify="center" >
                  <Col span={24}>
                    {
                      Object.entries(this.state.comment).map(element=>{
                        if (!element[1].comentario_padre){
                          return this.getChildComments(element[1])
                        }
                      })
                    }
                  </Col>
                </Row>
              </Modal>}
            </Content>
          </Layout>
        </ConfigProvider>
    </div>
    <Foot admin={true}/>
    </div>
    );
  }
}
export default AdminJuryProcess;


